$(document).ready(function(){
  $(".link_pd").on("click",function(){
    $(".popup_pd_content ").addClass('open_pd_pop');
    $('body').addClass('body_fix_pd');
  });

  $(".close_pd_pop").on("click",function(){
    $(".popup_pd_content").removeClass('open_pd_pop');
    $('body').removeClass('body_fix_pd');
  });
 });

  function glob() {
    // Select the first element with both 'lang' and 'langify_app_code' classes
    var el = document.querySelector('.lang.langify_app_code');
    if (el.style.display === "none" || el.style.display === "") {
      el.style.display = "block";
    } else {
      el.style.display = "none";
    }
  }


